import React from 'react';
import { Plus, X } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
export function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="bg-white border border-gold/20 rounded-lg overflow-hidden transition-all duration-200" data-id="element-11">
      <button className="w-full flex justify-between items-center px-5 py-4 bg-transparent border-none cursor-pointer font-dmsans text-[15px] font-semibold text-dark text-left gap-3 hover:bg-gold/5 transition-colors" onClick={onClick} aria-expanded={isOpen} data-id="element-12">
        <span data-id="element-13">{question}</span>
        <span className={`text-gold min-w-[20px] transition-transform duration-200 ${isOpen ? 'rotate-45' : ''}`} data-id="element-14">
          <Plus size={20} data-id="element-15" />
        </span>
      </button>

      <div className={`px-5 text-sm text-muted leading-relaxed border-t border-gold/10 pt-3.5 pb-4 transition-all duration-300 origin-top ${isOpen ? 'block opacity-100' : 'hidden opacity-0'}`} data-id="element-16">
        {answer}
      </div>
    </div>;
}